import 'css-chunk:../node_modules/.pnpm/react-day-picker@8.10.1_date-fns@2.30.0_react@17.0.2/node_modules/react-day-picker/dist/style.css';export default {};